import React from 'react'

export default function SmallSpacer({className}) {
    return (
        <div className={'h30 ' + (className ? className : '')} />
        
    )
}
